/**
 * @description
 * Objeto texts
 */

export class Texts {
    public id:number = null;
    public code:string = "";
    public desc:string = "";
    public valuecat:string = "";
    public valueesp:string = "";
    public enable:number=null;

  
    constructor() {}
  
}